import { render, staticRenderFns } from "./BuyDrug.vue?vue&type=template&id=336432bb&scoped=true&"
import script from "./BuyDrug.vue?vue&type=script&lang=js&"
export * from "./BuyDrug.vue?vue&type=script&lang=js&"
import style0 from "./BuyDrug.vue?vue&type=style&index=0&id=336432bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336432bb",
  null
  
)

export default component.exports